window.EG_HELP_CENTRE_DATA = {
  categoryLabels: {
    delivery: 'Delivery',
    returns: 'Returns',
    orders: 'Ordering',
    payment: 'Payment',
    warranty: 'Warranty',
    tracking: 'Tracking',
    business: 'Business',
    troubleshooting: 'Troubleshooting'
  },

  categoryExtras: {
    delivery: 'order_number',
    returns: 'order_number,product_name,product_serial',
    orders: 'order_number',
    payment: 'payment_method,order_number',
    warranty: 'order_number,related_gear',
    tracking: 'order_number',
    business: ''
  },

  FAQ_LIMIT: 7,
  SEARCH_RESULTS_LIMIT: 6,

  faqRegistry: {
    orders: [
      { subreason: 'orders_change', subject: 'Orders: Can I change my order?', question: 'Can I change my order?' },
      { subreason: 'orders_cancel', subject: 'Orders: Can I cancel my order?', question: 'Can I cancel my order?' },
      { subreason: 'orders_unfulfilled', subject: "Orders: My order hasn't been fulfilled yet", question: "My order hasn't been fulfilled yet, why not?" },
      { subreason: 'orders_payment_taken', subject: 'Orders: My order wasn’t successful but payment was taken', question: 'My payment was taken, but I didn’t receive an order confirmation' },
      { subreason: 'orders_refunded', subject: 'Orders: My order was cancelled and refunded', question: 'Why was my order automatically cancelled and refunded?' },
      { subreason: 'orders_oos', subject: 'Orders: My order is out of stock', question: 'An item in my order is out of stock — what happens now?' },
      { subreason: 'orders_discounts', subject: 'Orders: Do you have discounts available?', question: 'Do you have discounts available?' }
    ],

    payment: [
      { subreason: 'pay_surcharge', subject: 'Payment: Are there any surcharges?', question: 'Are there any surcharges for credit cards or PayPal?' },
      { subreason: 'pay_when', subject: 'Payment: When is payment taken?', question: 'When is payment taken?' },
      { subreason: 'pay_taken', subject: 'Payment: Payment taken but order failed', question: "My order wasn't successful but payment has been taken" },
      { subreason: 'pay_saved', subject: 'Payment: Are payment details saved?', question: 'Are my payment details saved on your system?' },
      { subreason: 'pay_refund', subject: 'Payment: Why was my payment refunded?', question: 'Why has my payment been refunded?' },
      { subreason: 'pay_confirmed', subject: 'Payment: What is PayPal confirmed?', question: 'What is PayPal confirmed?' },
      { subreason: 'pay_cancel_refund', subject: 'Payment: Refund after cancellation', question: "I've cancelled my order, when will I get my payment back?" }
    ],

    delivery: [
      { subreason: 'del_cutoff', subject: 'Delivery: Express delivery cut-off', question: "What's the cut-off for Express Delivery?" },
      { subreason: 'del_no_express', subject: 'Delivery: Express delivery unavailable', question: "Express Delivery wasn't available for my order" },
      { subreason: 'del_times', subject: 'Delivery: Delivery times', question: 'How soon will my order be delivered?' },
      { subreason: 'del_outside_uk', subject: 'Delivery: Do you deliver outside the UK?', question: 'Do you deliver outside the UK?' },
      { subreason: 'del_weekend', subject: 'Delivery: Weekend delivery', question: 'Do you deliver on weekends?' },
      { subreason: 'del_notifications', subject: 'Delivery: Shipping notifications', question: 'Will I receive shipping notifications?' },
      { subreason: 'del_where', subject: "Delivery: Where's my order?", question: "Where's my order?" },
      { subreason: 'del_tracking_delay', subject: 'Delivery: Tracking not updating', question: "Why isn't my tracking information showing yet?" },
      { subreason: 'del_rm_tracking', subject: 'Delivery: Missing tracking details', question: "Why haven't I received tracking details?" },      { subreason: 'del_couriers', subject: 'Delivery: Couriers used', question: 'Which delivery companies do you use?' },
      { subreason: 'del_split', subject: 'Delivery: Split shipments', question: 'Will my items all come in the same delivery?' },
      { subreason: 'del_missed', subject: 'Delivery: Missed delivery', question: 'I missed my delivery, what are my options?' },
      { subreason: 'del_missing_item', subject: 'Delivery: Missing item', question: 'An item is missing from my order. Where is it?' },
      { subreason: 'del_delivered_no_parcel', subject: 'Delivery: Tracking says delivered but I don’t have it', question: 'Tracking says delivered but I don’t have my order' },
      { subreason: 'del_return_to_sender', subject: 'Delivery: My parcel is being returned to sender', question: 'My tracking says “Return to sender”' },
      { subreason: 'del_change_address', subject: 'Delivery: Can I change my delivery address?', question: 'Can I change my delivery address after ordering?' },
      { subreason: 'del_why_delayed', subject: 'Delivery: Why is my delivery delayed?', question: 'Why was my delivery delayed?' },
      { subreason: 'del_damaged_redirect', subject: 'Delivery: Damaged item redirection', question: 'My item is damaged – what should I do?' }
    ],

    returns: [
      { subreason: 'ret_return', subject: 'Returns: How do I start a return?', question: 'How do I start a return?' },
      { subreason: 'ret_mind', subject: 'Returns: How long do I have to return an item?', question: 'How long do I have to return an item?' },
      { subreason: 'ret_cost', subject: 'Returns: Do I have to pay for return shipping?', question: 'Do I have to pay for return shipping?' },
      { subreason: 'ret_refund_delay', subject: 'Returns: My return was delivered — where is my refund?', question: 'My return was delivered — where is my refund?' },
      { subreason: 'ret_faulty_arrival', subject: 'Returns: What if my item is faulty on arrival?', question: 'What if my item is faulty on arrival?' },
      { subreason: 'ret_faulty_later', subject: 'Returns: What if my item develops a fault later?', question: 'What if my item develops a fault later?' },
      { subreason: 'ret_replacement', subject: 'Returns: Replacement before return', question: 'Can you send a replacement before I return the faulty item?' },
      { subreason: 'ret_serial_number', subject: 'Returns: Where do I find my product serial number?', question: 'Where do I find my product serial number?' }
    ],

    warranty: [
      { subreason: 'ret_faulty_later', subject: 'Warranty: Product developed a fault', question: 'The product has started showing a fault, how do I get it fixed?' },
      { subreason: 'warranty_route', subject: 'Warranty: Who handles my warranty claim?', question: 'Who handles my warranty claim?' }
    ],

    tracking: [
      { subreason: 'track_order_lookup', subject: 'Tracking: Track my order', question: 'Track my order' },
      { subreason: 'track_help', subject: 'Tracking: Tracking help', question: 'I need help with tracking' }
    ],

    business: [
      { subreason: 'biz_brand', subject: 'Business: Sell your products with us', question: 'Sell your products with us' },
      { subreason: 'biz_bulk', subject: 'Business: Bulk or team order', question: 'Bulk or team order' },
      { subreason: 'biz_reseller', subject: 'Business: Reseller or trade account', question: 'Do you offer reseller or trade accounts?' },
      { subreason: 'biz_sponsorship', subject: 'Business: Sponsorship or partnership', question: 'Sponsorship or partnership' },
      { subreason: 'biz_other', subject: 'Business: Other enquiry', question: 'Other business enquiry' }
    ]
  },

  FAQ_SEARCH_KEYWORDS: {
    track_order_lookup: [
      'track order', 'tracking', 'track my parcel', 'track my package', 'track shipment',
      'where is my parcel', 'where is my package', 'where is my order', 'order tracker',
      'tracking number', 'tracking details', 'delivery status', 'parcel status'
    ],
    track_help: [
      'tracking help', 'tracking issue', 'tracking problem', 'tracking not working',
      'tracking not updating', 'tracking delayed', 'tracking missing', 'no tracking',
      'cant track order', 'cannot track order', 'track order not found', 'tracking support'
    ],

    del_cutoff: [
      'cut off', 'cutoff', 'express cut off', 'express cutoff', 'express cut off',
      'same day dispatch', 'dispatch today', 'order before 3:30pm', 'express deadline'
    ],
    del_no_express: [
      'no express delivery', 'express unavailable', 'cant choose express',
      'cannot choose express', 'express not available', 'next day unavailable'
    ],
    del_times: [
      'delivery time', 'delivery times', 'shipping time', 'shipping times',
      'how long delivery', 'how long shipping', 'when will it arrive',
      'delivery estimate', 'estimated delivery', 'standard delivery', 'free delivery',
      'free no-rush', 'no rush delivery', 'express delivery', 'standard delivery'
    ],
    del_outside_uk: [
      'outside uk', 'international shipping', 'international delivery',
      'ship abroad', 'ship overseas', 'deliver outside uk', 'europe shipping', 'worldwide shipping'
    ],
    del_weekend: [
      'weekend delivery', 'deliver saturday', 'deliver sunday',
      'saturday delivery', 'sunday delivery', 'weekend shipping'
    ],
    del_notifications: [
      'shipping notification', 'dispatch email', 'tracking email', 'delivery email',
      'shipping update', 'will i get email', 'will i get notified', 'sms update'
    ],
    del_where: [
      'where is my order', 'wheres my order', 'where is my parcel', 'late parcel',
      'late delivery', 'parcel late', 'order late', 'order not arrived', 'not arrived',
      'still not here', 'stuck delivery', 'delivery overdue', 'order stuck'
    ],
    del_tracking_delay: [
      'tracking delay', 'tracking delayed', 'tracking not updating', 'tracking stuck',
      'no tracking update', 'tracking hasnt updated', 'tracking not moving',
      'parcel not moving', 'shipment not moving'
    ],
    del_rm_tracking: [
      'tracking details', 'missing tracking', 'no tracking received',
      'tracking email', 'tracking number', 'where is my tracking',
      'royal mail tracking', 'no royal mail tracking', 'missing royal mail tracking',
      'royal mail not sent tracking', 'royal mail text', 'royal mail email',
      'rm tracking', 'royal mail update'
    ],
    del_couriers: [
      'courier', 'couriers', 'who delivers', 'delivery company',
      'which courier', 'who do you use', 'dpd', 'royal mail', 'evri', 'ups', 'fedex'
    ],
    del_split: [
      'split shipment', 'split delivery', 'multiple parcels', 'separate parcels',
      'separate delivery', 'more than one parcel', 'items in same parcel'
    ],
    del_missed: [
      'missed delivery', 'missed parcel', 'not in when delivered',
      'redelivery', 're delivery', 'rearrange delivery', 'calling card'
    ],
    del_missing_item: [
      'missing item', 'item missing', 'wrong item', 'missing product',
      'part of order missing', 'parcel missing item', 'didnt receive all items'
    ],
    del_delivered_no_parcel: [
      'delivered but not received', 'says delivered but no parcel',
      'tracking says delivered', 'parcel marked delivered', 'delivered no parcel',
      'missing delivered parcel', 'proof of delivery wrong'
    ],
    del_return_to_sender: [
      'return to sender', 'returned to sender', 'rts',
      'parcel going back', 'shipment returned'
    ],
    del_change_address: [
      'change address', 'change delivery address', 'wrong address',
      'incorrect address', 'update address', 'edit address after order'
    ],
    del_why_delayed: [
      'why delayed', 'delivery delayed', 'parcel delayed',
      'why is parcel late', 'why is delivery late', 'delay reason'
    ],
    del_damaged_redirect: [
      'damaged item', 'damaged parcel', 'arrived damaged',
      'broken in transit', 'package damaged', 'box damaged'
    ],

    orders_discounts: [
      'discount', 'discounts', 'voucher', 'promo code', 'promotion',
      'offer', 'coupon', 'sale price', 'cheaper price'
    ],
    orders_payment_taken: [
      'payment taken no order', 'money taken no order', 'charged but no order',
      'order failed payment taken', 'payment pending no order', 'card charged no confirmation'
    ],
    orders_change: [
      'change order', 'edit order', 'swap item', 'change item',
      'change quantity', 'amend order', 'update order'
    ],
    orders_cancel: [
      'cancel order', 'cancel my order', 'order cancellation',
      'stop order', 'dont want order now'
    ],
    orders_oos: [
      'out of stock', 'oos', 'stock issue', 'item unavailable',
      'no stock', 'ordered item unavailable'
    ],
    orders_unfulfilled: [
      'unfulfilled', 'not fulfilled', 'not dispatched', 'not shipped',
      'processing too long', 'why hasnt it shipped', 'why not dispatched'
    ],
    orders_refunded: [
      'order refunded', 'cancelled and refunded', 'refunded order',
      'why refunded', 'why cancelled', 'auto refunded'
    ],

    pay_surcharge: [
      'payment surcharge', 'paypal fee', 'card fee', 'extra payment fee',
      'pay by card fee', 'paypal charge'
    ],
    pay_when: [
      'when charged', 'when is payment taken', 'when do you take payment',
      'payment timing', 'charged at checkout'
    ],
    pay_taken: [
      'payment taken no order', 'charged but failed', 'money taken failed order',
      'payment failed but charged', 'bank took payment'
    ],
    pay_saved: [
      'save card', 'saved payment details', 'store my card',
      'payment details saved', 'card details stored'
    ],
    pay_refund: [
      'refund', 'payment refunded', 'why refunded', 'refunded payment',
      'where is my refund', 'refund status'
    ],
    pay_confirmed: [
      'paypal confirmed', 'confirmed paypal address', 'what is paypal confirmed',
      'paypal verification'
    ],
    pay_cancel_refund: [
      'cancelled order refund', 'refund after cancellation',
      'cancel refund time', 'when will i get refund after cancelling'
    ],

    ret_return: [
      'return', 'return item', 'how to return', 'arrange return',
      'send back', 'return process', 'return label'
    ],
    ret_cost: [
      'return cost', 'free returns', 'cost to return',
      'do i pay return postage', 'return postage', 'return shipping cost'
    ],
    ret_mind: [
      'changed mind', 'dont want item', 'no longer needed',
      'return unwanted', 'return unopened', 'return unused'
    ],
    ret_serial_number: [
      'serial number', 'where is serial number', 'find serial number',
      'product serial', 'sn number'
    ],
    ret_faulty_arrival: [
      'arrived faulty', 'dead on arrival', 'doa', 'not working on arrival',
      'faulty out of box', 'broken on arrival'
    ],
    ret_faulty_later: [
      'developed fault', 'stopped working later', 'fault after use',
      'warranty fault', 'item broke later', 'intermittent fault'
    ],
    ret_replacement: [
      'replacement before return', 'advance replacement', 'send replacement first',
      'replacement before sending back'
    ],
    ret_refund_delay: [
      'return delivered refund', 'where is my refund', 'refund delay',
      'return refund not received', 'return processed', 'refund after return',
      'returned item refund', 'refund pending'
    ],
    warranty_route: [
      'warranty', 'warranty claim', 'manufacturer warranty',
      'who handles warranty', 'rma', 'repair', 'replacement warranty',
      'fault developed later', 'product warranty', 'brand warranty'
    ],

    biz_brand: [
      'sell with esports gear', 'stock my brand', 'stock our brand', 'be stocked',
      'brand partnership', 'sell products with you', 'wholesale to esports gear',
      'become a brand partner', 'have you stock our products', 'list our products'
    ],
    biz_bulk: [
      'bulk order', 'team order', 'large order', 'multiple units',
      'organisation order', 'corporate order'
    ],
    biz_reseller: [
      'reseller', 'trade account', 'wholesale', 'dealer account',
      'trade pricing', 'b2b account'
    ],
    biz_sponsorship: [
      'sponsorship', 'sponsor', 'partnership', 'collaboration',
      'creator partnership', 'team sponsorship'
    ],
    biz_other: [
      'business enquiry', 'business inquiry', 'corporate enquiry',
      'trade enquiry', 'company order', 'office order'
    ]
  },

  issueCopy: {
        tracking: {
          tracking_not_updating: `
            <ul>
              <li>Tracking can update in batches and may pause overnight.</li>
              <li>Please allow time for your tracking to be generated and begin updating after dispatch.</li>
              <li>If there has been no movement for 48 hours, fill out the form below and we’ll investigate.</li>
            </ul>
          `,
          delivered_not_received: `
            <ul>
              <li>Check safe places, neighbours, reception and any delivery photo first.</li>
              <li>If you still cannot find it, fill out the form below and we’ll investigate.</li>
            </ul>
          `,
          missing_item_or_split: `
            <ul>
              <li>Some orders ship in more than one parcel.</li>
              <li>Check your confirmation and tracking results first.</li>
              <li>If something is still missing, fill out the form below and we’ll investigate.</li>
            </ul>
          `,
          order_not_dispatched: `
            <ul>
              <li>Orders can remain unshipped while stock is being prepared or awaiting collection.</li>
              <li>Orders placed after 3:30pm, on weekends or on bank holidays are processed on the next business day.</li>
              <li>If your order has still not been dispatched after the next business day, fill out the form below and we’ll check it for you.</li>
            </ul>
          `,
          change_address: `
            <ul>
              <li>Address changes are only possible before dispatch.</li>
              <li>If the parcel has already shipped, changes may no longer be possible.</li>
            </ul>
          `,
          other: `
            <ul>
              <li>If your tracking issue does not fit the options above, give us a short summary below.</li>
            </ul>
          `
        },
    delivery: {
      delayed_delivery: `
          <ul>
            <li>Check your tracking first where possible.</li>
            <li>Delivery estimates are in business days only. Weekends and bank holidays do not count.</li>
            <li>Express Delivery is typically 1-2 business days, Standard Delivery 2-3 business days, and Free No-Rush Delivery 4-5 business days.</li>
            <li>If your order is beyond the expected delivery timeframe and there’s been no movement for 48 hours, fill out the form below and we’ll investigate.</li>
          </ul>
      `,
      missing_items: `
       <ul>
        <li>Check your order confirmation and packing slip first.</li>
        <li>Some orders ship in more than one parcel.</li>
        <li>Fill out the form below within 48 hours if something’s missing and we’ll investigate.</li>
        <li>Claims must be reported within 7 days of delivery.</li>
      </ul>
      `,
      damaged_items: `
      <ul>
        <li>Keep all packaging and take clear photos of the box, labels, and damage.</li>
        <li>Fill out the form below and attach the photos so we can resolve it quickly.</li>
        <li>Claims must be reported within 7 days of delivery.</li>
      </ul>
      `,
      delivered_no_parcel: `
      <p><strong>This type of request requires a signed denial form before we can investigate.</strong></p>
      <p>Check safe places, neighbours, reception or communal areas, and the delivery photo first. If it's not there:</p>
        <ol>
          <li>Download this <a target="_blank" href="https://esportsgear.sharepoint.com/:b:/s/external/IQBiCajLTgvzQIFFQzFVFuJZAXETuhk1Z8PvAn85Bw4MCwg?e=g1DLeV">printable denial receipt form</a>.</li>
          <li>Print it out, then sign and date it. </li>
          <li>Take a clear photo of the signed form with your phone.</li>
          <li>Attach the photo to the contact form below. JPG, PNG, or PDF is fine.</li>
          <li>Complete the rest of the contact form and submit it. </li>
          <li>We’ll investigate with the courier and get back to you as soon as possible.</li>
        </ol>
      `,
      change_address: `
      <ul>
        <li>Address changes are only possible before dispatch and usually only for small typos.</li>
        <li>If the address is completely different, for security we’ll cancel and refund the order so you can place it again with the correct details.</li>
      </ul>
        `,
      other: `
      <ul>
        <li>If your delivery issue doesn’t fit the options above, give us a short summary in the message field.</li>
        <li>Including your order number and tracking details helps us get straight to the important details.</li>
      </ul>
      `
    },
    returns: {
      changed_mind:
      `<ul>
        <li>This option is only for items you have already received.</li>
        <li>If your order has not been dispatched yet and you wish to cancel it, please use our <a href="/pages/help?hc=orders&f=orders_cancel">Order Cancellation guide</a> instead.</li>
        <li>You have 30 days from delivery to request a return.</li>
        <li>The item must be unused, in “as new” condition, and in its original packaging.</li>
        <li>Return shipping is paid by the customer for changed-mind returns.</li>
        <li>All orders are recorded and photographed before dispatch, and all returns are recorded on arrival to verify condition and serials.</li>
      </ul>`,
      faulty_item:
      `<ul>
        <li>Please check our <a href="https://esportsgear.uk/pages/help?hc=troubleshooting">Troubleshooting Guide</a> first for common fixes.</li>
        <li>If the problem remains, fill out the form below and include clear photos where possible.</li>
        <li>All orders are recorded and photographed before dispatch, and all returns are recorded on arrival to verify condition and serials.</li>
      </ul>`
    },
    orders: {
      change_order:
        'We can usually change your order if it hasn’t been picked or dispatched yet. Tell us exactly what you’d like to change (items, quantities or address) and we’ll confirm what’s possible.',
      cancel_order:
        'If your order hasn’t shipped yet, we can often cancel it in full. Once it’s been dispatched, it’s usually treated as a standard return instead. Include your order number so we can check the status quickly.',
      stock_issue:
        'If an item is out of stock or delayed, we can look at alternatives, partial shipping or a refund for that line. Let us know if you’d prefer to wait, swap to something similar, or cancel the affected item.',
      other:
        'If your order question doesn’t match the options above, describe what’s happened and what you’re hoping to do (for example change items, combine orders, or update details).'
    },
    payment: {
      payment_taken_no_order:
        'Sometimes banks reserve funds even when an order fails. These “pending” charges usually drop off automatically after a few business days. If you have a transaction but no order confirmation, tell us the time, amount and payment method so we can double-check.',
      refund_question:
        'Refunds are usually processed on our side quickly, but banks and payment providers can take several business days to show them on your account. Include your order number and when we confirmed the refund so we can review the status.',
      pay_later_options:
        'Pay-later and finance options are handled by providers like Klarna or your card issuer. If there’s an issue with instalments or due dates, they may need to help first, but we can confirm order and refund status at our end.',
      other:
        'For any other payment issue, include the order number (if you have one), the amount, payment method and any reference shown on your statement. That gives us the best chance of finding it quickly.'
    },
    warranty: {},
    business: {
      brand_partnership:
        'If you’re a brand looking to have your products stocked by Esports Gear, tell us about your product range, target market, current distribution and include links to your website or catalogue so we can review it properly.',
      bulk_order:
        'For bulk or team orders, include a rough idea of quantities, which products you’re interested in and your timeframe. We can then check stock, pricing and possible discounts before coming back to you.',
      sponsorship:
        'For sponsorship or partnership requests from teams, creators or event organisers, include links to your channels, audience size and any relevant stats or examples. We review proposals periodically and will get back to you if there’s a good fit.',
      other:
        'For any other business enquiry, give us a short summary of what you have in mind and how we can contact you. The more specific you can be, the easier it is for us to route it to the right person.'
    }
  },

  detailsPlaceholder: {
    tracking: {
      tracking_not_updating:
        'Tell us your order number, the latest tracking status and when it last updated.',
      delivered_not_received:
        'Tell us where tracking says it was delivered, what checks you have already made, and your order number.',
      missing_item_or_split:
        'Tell us which item is missing or which parcel appears delayed, and include your order number.',
      order_not_dispatched:
        'Tell us your order number and why you think dispatch is overdue.',
      change_address:
        'Tell us the correct delivery address and your order number so we can check whether it can still be changed.',
      other:
        'Tell us what tracking help you need and include your order number if you have it.'
    },
    delivery: {
      delivered_no_parcel:
        'Tell us what happened, including where tracking says it was delivered and your order number.',
      change_address:
        'Tell us the correct delivery address and your order number so we can update or advise next steps.',
      delayed_delivery:
        'Tell us what’s happened with your delivery, including order number and any tracking info.',
      missing_items:
        'Tell us which items are missing and what should have been in the parcel.',
      damaged_items:
        'Describe the damage and mention if you have photos of the box, labels and item.',
      other:
        'Describe your delivery issue and include your order number if you have one.'
    },
    returns: {
      changed_mind:
        'What would you like to return? Include item name(s) and delivery date.',
      faulty_item:
        'What’s wrong with your gear? Provide as much detail on the issue as possible so we can best help you.'
    },
    orders: {
      change_order:
        'Tell us what you’d like to change (items, quantities or address), plus your order number.',
      cancel_order:
        'Tell us which order you’d like to cancel and whether the parcel has already shipped.',
      stock_issue:
        'Tell us which item is affected and whether you’d prefer to wait, swap or cancel it.',
      other:
        'Describe your order question and what you’re trying to do.'
    },
    payment: {
      payment_taken_no_order:
        'Tell us the time, amount and payment method shown on your statement.',
      refund_question:
        'Tell us your order number, refund amount and when we confirmed the refund.',
      pay_later_options:
        'Describe the pay-later/finance issue and which provider you’re using.',
      other:
        'Tell us about your payment issue, including any reference shown on your statement.'
    },
    warranty: {},
    business: {
      brand_partnership:
        'Tell us about your brand, product range, pricing position, distribution, target market and include links to your website or catalogue.',
      bulk_order:
        'Tell us roughly how many units you need, which products and your timeframe.',
      sponsorship:
        'Share links to your channels, audience size, platform stats and what kind of partnership you’re looking for.',
      other:
        'Describe your business enquiry and how we can help.'
    }
  },

  issueToFaq: {
      tracking: {
        tracking_not_updating: 'track_help',
        delivered_not_received: 'track_help',
        missing_item_or_split: 'track_help',
        order_not_dispatched: 'track_help',
        change_address: 'track_help',
        other: 'track_help'
      },
    delivery: {
      delayed_delivery: [
        'del_where',
        'del_times',
        'del_tracking_delay',
        'del_why_delayed',
        'del_rm_tracking'
      ],
      missing_items: [
        'del_missing_item',
        'del_split'
      ],
      damaged_items: [
        'del_damaged_redirect'
      ],
      delivered_no_parcel: [
        'del_delivered_no_parcel',
        'del_where',
        'del_missed'
      ],
      change_address: [
        'del_change_address',
        'del_return_to_sender',
        'del_times'
      ],
      other: [
        'del_times',
        'del_couriers',
        'del_notifications'
      ]
    },
    returns: {
      changed_mind: 'ret_mind',
      faulty_item: 'ret_serial_number',
    },
    orders: {
      change_order: 'orders_change',
      cancel_order: 'orders_cancel',
      orders_unfulfilled: 'orders_unfulfilled',
      orders_refunded: 'orders_refunded'
    },
    payment: {
      payment_taken_no_order: 'pay_taken',
      refund_question: 'pay_refund',
      other: 'pay_surcharge'
    },
  warranty: {},
    business: {
      brand_partnership: 'biz_brand',
      bulk_order: 'biz_bulk',
      sponsorship: 'biz_sponsorship',
      other: 'biz_other'
    }
  },

  faqContent: {
    // ORDERS
    orders_discounts: `
      <p>Any active discounts or promotions are normally shown directly on the website or sent through our newsletter.</p>
      <p>We’re not usually able to manually apply, combine or backdate discounts outside of the advertised promotion terms.</p>
    `,

    orders_payment_taken: `
      <p>If a payment attempt fails, your bank may still place a temporary authorisation on the funds while it waits for confirmation from the payment provider.</p>
      <p>Because the order does not complete on our side, the pending amount is usually released automatically by your bank after a few business days.</p>
      <p>You do not need to take any action unless the charge is still showing after a few business days.</p>
    `,

    orders_change: `
      <p>If you need to change items, quantities or delivery details, contact us as soon as possible after placing the order.</p>
      <p>We can usually help before your order has been picked and handed to the courier. Once a shipping confirmation has been issued, changes are usually no longer possible.</p>
      <p>If your order has already been dispatched, it will need to follow the normal delivery or returns process instead.</p>
    `,

    orders_cancel: `
      <p>You can request a cancellation as long as the order has not yet been collected from our warehouse or had its shipping confirmation issued.</p>
      <p>If the parcel is already on its way, the easiest option is usually to refuse delivery or treat it as a standard return instead.</p>
      <p>If the order has already shipped, you do not need to contact us to cancel.</p>
    `,

    orders_oos: `
      <p>If an item in your order is out of stock, we’ll contact you with the options available.</p>
      <p>This may include waiting for restock, choosing an alternative, partial shipment or refunding the affected item.</p>
    `,

    orders_unfulfilled: `
      <p>Your order shows as “Fulfilled” once the courier has collected your gear from our warehouse.</p>
      <p>Orders placed after 3:30pm Monday to Friday are usually processed on the next business day. Orders are not processed on weekends or bank holidays.</p>
      <p>This means an order can still appear unfulfilled for a while even when everything is progressing normally.</p>
      <p>If your order was placed recently, especially after 3:30pm or outside business days, you do not usually need to do anything yet.</p>
      <p>If your order has not been fulfilled after the next business day, you can contact us and we’ll check it for you.</p>
    `,

    orders_refunded: `
      <p>Some orders are automatically cancelled and refunded if they cannot be processed as placed.</p>
      <p>This can happen due to stock issues, payment review checks, address problems or other order validation steps.</p>
      <p>If you are unsure why this happened, contact us with your order number and we’ll confirm the reason.</p>
    `,

    // PAYMENTS
    pay_surcharge: `
      <p>No, we don’t add extra fees for paying by card or PayPal. The total you see at checkout (including shipping) is what you’ll pay, without hidden payment surcharges.</p>
    `,
    pay_when: `
      <p>For card and PayPal payments, the charge is taken when you complete checkout. For “pay later” options like Klarna, your payment date follows their schedule (for example, a set number of days after the order has shipped).</p>
    `,
    pay_taken: `
      <p>If a payment attempt fails, your bank may temporarily reserve funds while expecting confirmation from our payment provider. Because the transaction is declined on our side, the pending amount is released back to your account. This can take several business days depending on your bank.</p>
    `,
    pay_saved: `
      <p>We don’t store your card details on our website. Payments are processed securely through providers such as PayPal and Shopify Payments, which handle your sensitive information according to their own security and privacy standards.</p>
    `,
    pay_refund: `
      <p>A common reason is when PayPal or your bank can’t fully confirm your billing details, so they automatically refund the transaction instead of completing it. Once refunded, the money returns to your account according to your bank or PayPal’s timescales.</p>
    `,
    pay_confirmed: `
      <p>A confirmed PayPal address is an extra fraud-prevention measure. It helps verify that the card being used belongs to you, and we only ship PayPal orders to confirmed addresses to help protect both you and us against fraud.</p>
    `,
    pay_cancel_refund: `
      <p>Once we confirm a cancellation, we start processing your refund right away. In most cases this appears back in your account within around three to four business days, although some banks can take longer. If the order has already shipped, we’ll need to treat it as a return instead.</p>
    `,

    // TRACKING
    track_order_lookup: `
      <p>You can use the tracking widget below to look up your order status.</p>
      <p>All orders include tracking. If your tracking is not updating yet, please allow normal courier processing time first.</p>
    `,
    track_help: `
      <p>If you’re having trouble with tracking, first try the tracking widget below using your tracking number or order details.</p>
      <p>If the result still doesn’t make sense, you can continue to the contact form and we’ll investigate.</p>
    `,

    // DELIVERY
    del_cutoff: `
      <p>Order before 3:30pm Monday-Friday for same-day dispatch on Express Delivery.</p>
      <p>Orders placed after the cut-off ship the next business day.</p>
      <p>Express Delivery typically arrives within 1-2 business days after dispatch.</p>
    `,
    del_no_express: `
      <p>Some items ship from specific warehouses or suppliers where Express Delivery isn’t supported. In these cases, checkout will only show the services available for that item.</p>
    `,
    del_times: `
      <p>Express Delivery typically arrives within 1-2 business days.</p>
      <p>Standard Delivery typically arrives within 2-3 business days.</p>
      <p>Free No-Rush Delivery typically arrives within 4-5 business days.</p>
      <p>Business days are Monday to Friday only. Weekends and bank holidays do not count.</p>
      <p>Delays can happen due to weather, courier backlogs, routing changes, or peak demand.</p>
    `,
    del_outside_uk: `
      <p>Right now we focus on serving customers within the UK so we can offer better stock levels, pricing and support. International shipping isn’t available yet, but it’s something we may explore in future.</p>
    `,
    del_weekend: `
      <p>Not currently. Deliveries are made Monday–Friday only.</p>
    `,
    del_notifications: `
      <p>Yes — you’ll receive:</p>
      <ul>
        <li>A dispatch email when your gear leaves our warehouse</li>
        <li>Tracking details once your order has been dispatched</li>
        <li>Additional delivery updates where available from the courier</li>
      </ul>   
    `,
    del_where: `
      <p>Once your order is marked “Shipped,” it’s with the courier.</p>
      <p>Tracking usually updates within a few hours but can take up to 24 hours.</p>
      <p>All orders include tracking and tracking details are sent once your order has been dispatched.</p>
      <p>Delivery estimates and delays are based on business days only. Weekends and bank holidays do not count.</p>
      <p>Please allow 1 to 2 extra business days after the expected delivery date before contacting us.</p>
      <p>If it’s still not arrived after that, fill out the contact form on this page.</p>
    `,
    del_tracking_delay: `
      <p>Tracking often updates in batches. It's normal for tracking to remain unchanged for several hours, especially overnight or shortly after dispatch.</p>
      <p>If there has been no movement for 48 hours, contact us and we'll investigate.</p>
    `,
    del_rm_tracking: `
      <p>All orders include tracking.</p>
      <p>Tracking details are normally sent once your order has been dispatched.</p>
      <p>If you haven't received tracking, check your spam or junk folder first.</p>
      <p>Tracking can sometimes take several hours to begin updating after dispatch.</p>
      <p>If you still haven't received tracking by the next business day, fill out the contact form on this page.</p>
    `,
    del_couriers: `
      <p>We work with a range of trusted delivery partners depending on the size, weight and destination of your order.</p>
      <p>Every order includes tracking, and you'll receive tracking details once your order has been dispatched.</p>
    `,
    del_split: `
      <p>Most orders ship in a single parcel, but if items come from different warehouses you may receive multiple deliveries. We’ll let you know if this happens — there’s no extra cost.</p>
    `,
    del_missed: `
      <p>Couriers will usually attempt redelivery on the next business day. You can also use the calling card, email or SMS to rearrange delivery.</p>
    `,
    del_missing_item: `
      <p>If something is missing, please contact us within 48 hours of delivery. Our warehouses use camera and weight checks to confirm what was packed, so we can investigate quickly and resolve it for you.</p>
    `,
    del_delivered_no_parcel: `
      <p>If tracking shows “Delivered” but you don’t have the parcel, first check safe places, neighbours and anyone else at your address who might have accepted it. Couriers sometimes leave parcels in secure locations.</p>
      <p>If you still can’t find it after checking locally, contact us and we’ll open an investigation with the courier.</p>
    `,
    del_return_to_sender: `
      <p>“Return to Sender” usually means the courier couldn’t complete delivery, the address was incomplete, or the parcel was held too long at a pickup point.</p>
      <p>Once it arrives back with us, we’ll contact you to confirm whether you’d like it re-sent (if possible) or refunded.</p>
    `,
    del_change_address: `
      <p>We can update the delivery address only before your order is packed and collected by the courier. Once it’s been handed over, we can’t guarantee any changes.</p>
      <p>If you need to change the address, contact us as soon as possible with your order number and the correct details.</p>
    `,
    del_why_delayed: `
      <p>Delays can happen due to weather, courier backlogs, routing changes, or peak demand. Tracking updates are sometimes delayed, even while the parcel is still moving.</p>
      <p>If your tracking hasn’t updated for 48 hours or your delivery is past the estimated date, fill out the contact form on this page.</p>
    `,
    del_damaged_redirect: `
      <p>If your item has arrived damaged, this is handled under our <strong>Returns &amp; Warranty</strong> process rather than Delivery.</p>
      <p>Please report delivery damage as soon as possible and within 3 calendar days of delivery so we can investigate with the courier.</p>
      <p>Please choose the <strong>Returns</strong> subject and then select <strong>“Item arrived faulty”</strong> so we can resolve this for you as quickly as possible.</p>
      <p>If possible, include photos of the packaging, shipping label and the damaged item when submitting your request - it helps us process replacements much faster.</p>
    `,

    // RETURNS
    ret_return: `
      <p>To start a return, submit a return request using the form below.</p>
      <p>Once we’ve reviewed it, we’ll confirm the next steps and let you know how to send the item back.</p>
    `,
    ret_cost: `
      <p>Return shipping is paid by the customer unless the item is faulty or incorrect.</p>
      <p>If your item has arrived faulty or damaged, include clear photos when submitting your request so we can review it quickly.</p>
    `,
    ret_refund_delay: `
      <p>Refunds are usually processed within 2–3 business days after we receive and inspect your return.</p>
      <p>If your return was delivered back less than 3 business days ago, no action is needed yet.</p>
    `,
    ret_mind: `
      <p>You can request a return within 30 days of delivery.</p>
      <p>The item must be unused and in original condition to be eligible for a standard return.</p>
    `,
    ret_serial_number: `
      <p>Depending on the product, it’s usually located on the base of the item or on the product’s package.</p>
      <p>For headsets, it can be on or inside the earcup.</p>
      <p>If you can’t find it, a simple google search can help (e.g. “serial number location for [insert product name & model]”).</p>
    `,
    ret_faulty_arrival: `
      <p>If your item arrived faulty or damaged, submit a request using the form below and include clear photos of the issue.</p>
      <p>We’ll review it and confirm the next steps as quickly as possible.</p>
    `,
    ret_faulty_later: `
      <p>If your item has developed a fault after use, first check our troubleshooting guidance if available.</p>
      <p>If the issue remains, submit a request below with clear details of the fault, along with photos or video if possible.</p>
    `,
    ret_replacement: `
      <p>We’re not able to offer advanced replacements. As soon as we receive the item and confirm the fault, we’ll arrange a replacement or other agreed resolution and ship it out as quickly as possible.</p>
    `,

    // WARRANTY
    warranty_route: `
      <p>Some brands are handled directly by the manufacturer, while others are handled through Esports Gear.</p>
      <p>Check the manufacturer table below to see the correct route for your brand before submitting a claim.</p>
    `,

    // BUSINESS
    biz_brand: `
      <p>If you’re a brand looking to have your products stocked by Esports Gear, we’d be happy to hear from you.</p>
      <p>Please include details about your product range, current distribution, target markets and any relevant links so we can review it properly.</p>
      <p>If this sounds like a good fit, fill in the business form below and select <strong>“Sell your products with us”</strong>.</p>
    `,

    biz_bulk: `
      <p>If you’re ordering for a team, organisation or event, let us know roughly how many units you’re interested in, which products you have in mind and your timeframe.</p>
      <p>We can review stock, pricing and possible bulk options before getting back to you.</p>
      <p>To continue, fill in the business form below and select <strong>“Bulk or team order”</strong>.</p>
    `,

    biz_sponsorship: `
      <p>If you’re a team, creator or organiser looking for sponsorship or a partnership, include links to your main channels, audience size and relevant stats.</p>
      <p>We review proposals periodically and will get back to you if there’s a good fit.</p>
      <p>To submit a proposal, fill in the business form below and select <strong>“Sponsorship or partnership”</strong>.</p>
    `,

    biz_other: `
      <p>For anything else business-related, give us a brief overview of what you have in mind and how we can contact you.</p>
      <p>To continue, fill in the business form below and select <strong>“Other business enquiry”</strong>.</p>
    `,
    biz_reseller: `
      <p>We don’t currently offer reseller or trade accounts.</p>
      <p>If you’re a brand looking to have your products stocked by us instead, use the business form below and select <strong>“Sell your products with us”</strong>.</p>
    `,
  }
};